import styles from './LegalPage.module.css';

export function Support() {
  return (
    <div className={styles.legalPage}>
      <h1 className={styles.title}>Support</h1>
      <p className={styles.lastUpdated}>We're here to help</p>

      <div className={styles.content}>
        <h2>Contact Us</h2>
        <p>
          Have questions, feedback, or need assistance? Reach out to us at:<br />
          <a href="mailto:office@AIquadrat.com">office@AIquadrat.com</a>
        </p>

        <h2>Frequently Asked Questions</h2>

        <h3>Is the app free?</h3>
        <p>
          Yes, the app is completely free with no in-app purchases.
        </p>

        <h3>Does it work offline?</h3>
        <p>
          Yes, all core learning features work without an internet connection.
          Multiplayer races require an internet connection to sync with other players.
        </p>

        <h3>What devices are supported?</h3>
        <p>
          Our apps require iPhone or iPad running iOS 14.0 or later.
        </p>

        <h2>Report an Issue</h2>
        <p>
          If you're experiencing a problem, please contact us with the following information:
        </p>
        <ul>
          <li>A description of what went wrong</li>
          <li>Your device model and iOS version</li>
          <li>Steps to reproduce the issue</li>
        </ul>
        <p>
          This helps us investigate and resolve issues more quickly.
        </p>
      </div>
    </div>
  );
}
